import { useMutation } from 'react-query';

import forgotPasswordApi from '@/util/forgotPassword';

const useUserPasswordUpdateMutation = email =>
  useMutation(() => forgotPasswordApi.sendEmail({ email }));

export default useUserPasswordUpdateMutation;
